import React from "react";
import { DivisionData, TacticProviderProps, TacticState } from "./types";
import { TacticContext } from "./context";
import { DivisionsTree } from "@gettactic/api";
import { useDivisionsMenuQuery } from "@gettactic/hooks";

export const TacticProvider: React.FC<
  React.PropsWithChildren<TacticProviderProps>
> = ({ children }) => {
  const divisions = useDivisionsMenuQuery({ getFloors: true });

  const divisionCategories = React.useMemo(() => {
    const divisionsData: DivisionData = {
      offices: {},
      tree: divisions.data?.tree as DivisionsTree
    };

    const iterateDivisionTree = (division: DivisionsTree) => {
      if (division.offices) {
        division.offices.forEach((office) => {
          const officeAny = office as any;
          const floors = officeAny.floors || division.floors || [];
          divisionsData.offices[office.id] = {
            ...office,
            floors
          };
        });
      }

      if (division.children) {
        division.children.forEach(iterateDivisionTree);
      }
    };

    if (divisions.data?.tree) iterateDivisionTree(divisionsData.tree);

    return divisionsData;
  }, [divisions.data?.tree]);

  const value: TacticState = {
    divisionCategories
  };

  return (
    <TacticContext.Provider value={value}>{children}</TacticContext.Provider>
  );
};
